import {
  Box,
  Flex,
  Drawer,
  DrawerContent,
  useDisclosure,
} from '@chakra-ui/react';
import { Footer } from '../Footer';
import { SidebarContent } from './subcomponent/SidebarContent';
import { MobileNav } from './subcomponent/MobileNav';
import { BottomNavigation } from '../BottomNavigation';
import { useSelector } from 'react-redux';

const SidebarWithHeader = ({ children }: any) => {
  const { isSuccess } = useSelector((s: any) => s.auth || {});
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Flex direction="column" minH="100vh" bg="#f8fafc" position="relative">
      {isSuccess && (
        <>
          {/* Sidebar Desktop */}
          <SidebarContent
            onClose={onClose}
            display={{ base: 'none', xl: 'block' }}
          />

          {/* Drawer Mobile */}
          <Drawer
            isOpen={isOpen}
            placement="left"
            onClose={onClose}
            returnFocusOnClose={false}
            onOverlayClick={onClose}
            size="xs"
            blockScrollOnMount
          >
            <DrawerContent bg="#0f172a">
              <SidebarContent onClose={onClose} />
            </DrawerContent>
          </Drawer>

          {/* Sticky Top Header */}
          <MobileNav onOpen={onOpen} />
        </>
      )}

      {/* Main Content Area */}
      <Box
        as="main"
        flex="1"
        ml={isSuccess ? { base: 0, xl: '256px' } : 0}
        pb={isSuccess ? { base: '72px', md: 0 } : 0}
        display="flex"
        flexDirection="column"
      >
        {children}
      </Box>

      {isSuccess && (
        <>
          <Box
            as="footer"
            mt="auto"
            ml={{ base: 0, xl: '256px' }}
            display={{ base: 'none', md: 'block' }}
          >
            <Footer />
          </Box>
          <Box display={{ base: 'block', md: 'none' }}>
            <BottomNavigation onOpenDrawer={onOpen} />
          </Box>
        </>
      )}
    </Flex>
  );
};

export default SidebarWithHeader;
